/** @format */
import { Pipe, PipeTransform } from '@angular/core';
import { StudyEvent } from 'common-typescript/types';
import * as _ from 'lodash-es';
import moment from 'moment';
import { StudyEvent as GraphQLStudyEvent } from 'sis-common';

@Pipe({
    name: 'studyEventDateRange',
    standalone: false,
})
export class StudyEventDateRangePipe implements PipeTransform {
    transform(studyEvent: StudyEvent | GraphQLStudyEvent): string {
        if (_.isEmpty(studyEvent?.events)) {
            return '';
        }

        const events = studyEvent.events;
        const start = moment(events[0].start);
        const end = moment(events[events.length - 1].start);

        if (start === null && end === null) {
            return '';
        }

        if (start.isSame(end)) {
            return end.format('D.M.YYYY');
        }

        if (start.year() === end.year()) {
            return _.join([start.format('D.M.'), end.format('D.M.YYYY')], '–');
        }

        return _.join([start.format('D.M.YYYY'), end.format('D.M.YYYY')], '–');
    }
}
